// extracted by mini-css-extract-plugin
export default {"workplan-table":"LJs3Z"};